// Shared analytics value helpers usable outside composable/component context
// (e.g. router guards), per docs/Behavioral_Analysis_Mixpanel.md §4b.

// Namespaces a module-scoped enum value so it can't silently collide with a
// same-named value from a different module once a property (stage, funnel_stage,
// feature_name) is used in a cross-module report. See docs/Behavioral_Analysis_Mixpanel.md §5b.
export function namespacedValue(moduleCode, value) {
  return `${moduleCode}:${value}`
}

// Time Study's own record-type prefix (docs/Behavioral_Analysis_Mixpanel.md §1, Record IDs decision) —
// centralized here, rather than inlined at each call site, so it can't drift
// silently between the stage-tracking guard, the active-session key, and the
// completion events. See docs/Behavioral_Analysis_Mixpanel.md §4b.
//
// NOT a generic "any module's record type" — it's independent of Time Study's
// moduleCode ('station_design'), per docs/Behavioral_Analysis_Mixpanel.md §5c, so it
// can't be derived from moduleCode either. A future module adds its own sibling
// constant here (e.g. `export const LINE_STUDY_RECORD_TYPE = 'line_study'`) and
// builds its record id the same way Time Study does — call
// `namespacedValue(LINE_STUDY_RECORD_TYPE, id)` directly, no wrapper function
// needed; namespacedValue() already is the "format this id" helper.
export const TIME_STUDY_RECORD_TYPE = 'time_study'

// Calendar time elapsed since a record's server-assigned creation timestamp — idle time
// included, unlike active_duration_seconds (src/composables/useActiveSession.js), which
// excludes it. Generic (any record with a creation timestamp), not Time-Study-specific.
// Returns undefined (property omitted, not sent as 0/wrong) when timeCreated is missing —
// e.g. a stale/cached object shape — per docs/Behavioral_Analysis_Mixpanel.md §5e.
export function computeWallClockSeconds(timeCreated) {
  if (!timeCreated) return undefined
  return Math.round((Date.now() - new Date(timeCreated).getTime()) / 1000)
}
